import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { TruckingPackageDetailDto } from '@shared/src/dtos/trucking/TruckingPackageDetailDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { TruckingRouteActions } from '@shared/src/enums/TruckingRouteActions';
import { DragDropService } from '@shared/src/services/dragdrop/DragDropService';

@Component({
    selector: 'shared-trucking-package-card',
    templateUrl: './shared.trucking.package.card.html',
    styleUrls: ['./shared.trucking.package.card.scss']
})
export class SharedTruckingPackageCard implements OnInit {

    constructor(@Inject('HomeController') protected homeController: HomeController,
        public truckingController: TruckingController) {
        this.truckingController.shipmentPackageChanged$.subscribe((data: TruckingShipmentPackageDto) => {
            if (data && this.package && data.packageId == this.package.packageId)
                this.refresh.next(true);
        });
    }

    @Output() refresh = new EventEmitter<boolean>();
    @Output() clickDetail = new EventEmitter<boolean>();

    ngOnInit(): void { }

    @Input()
    public isDraggable: boolean = false;

    @Input()
    public inShipmentCard: boolean = false;

    private _package: TruckingShipmentPackageDto;
    @Input()
    public set package(value: TruckingShipmentPackageDto) {
        if (this._package === value)
            return;
        this._package = value;
        this.loadActions();
    }
    public get package(): TruckingShipmentPackageDto {
        return this._package;
    }

    private _selectedRouteExpand: TruckingRouteExpandDto;
    @Input()
    public set selectedRouteExpand(value: TruckingRouteExpandDto) {
        if (this._selectedRouteExpand === value)
            return;
        this._selectedRouteExpand = value;
        this.loadActions();
    }
    public get selectedRouteExpand(): TruckingRouteExpandDto {
        return this._selectedRouteExpand;
    }

    loadActions() {
        let showButtonPut = false;
        this.actions = new ActionsStripDto();
        if (this._package) {
            if (this.selectedRouteExpand){
                if (!this.selectedRouteExpand.isBrokenForTrucking && this.selectedRouteExpand.isTrucked) {
                    if (this.package.isTruckedPackage) {
                        if (this.package.isChildOfTrucking)
                            this.actions.add(SharedTruckingPackageCard.REMOVEPACKAGE);
                    } else {
                        if ((this.package != null && this.package.showDetail) || !this.inShipmentCard)
                            this.actions.add(SharedTruckingPackageCard.PUTPACKAGE);
                        showButtonPut = true;
                    }
                }else if (this.selectedRouteExpand.isBrokenForTrucking) {
                    if (this.package.isTruckedPackage) {
                        if(this.package.recover != null && this.package.recover.canRecover)
                            this.actions.add(SharedTruckingPackageCard.RECOVERPACKAGE);
                    } 
                }

            }
        }
        this.isDraggable = showButtonPut;
    }

    public static PUTPACKAGE: ActionDto = ActionDto.build("PUTPACKAGE", "TRUCKING.SHIPMENT.ACTIONS.PUTPACKAGE.CAPTION", "TRUCKING.SHIPMENT.ACTIONS.PUTPACKAGE.HELP", "fa-share", 20, 0, 1, "").addClass("action");
    public static REMOVEPACKAGE: ActionDto = ActionDto.build("REMOVEPACKAGE", "TRUCKING.SHIPMENT.ACTIONS.REMOVEPACKAGE.CAPTION", "TRUCKING.SHIPMENT.ACTIONS.REMOVEPACKAGE.HELP", "fa-times-circle", 10, 0, 1, "").addClass("action");
    public static RECOVERPACKAGE: ActionDto = ActionDto.build("RECOVERPACKAGE", "TRUCKING.SHIPMENT.ACTIONS.RECOVERPACKAGE.CAPTION", "TRUCKING.SHIPMENT.ACTIONS.RECOVERPACKAGE.HELP", "fa-times-circle", 10, 0, 1, "").addClass("action");


    public actions: ActionsStripDto;
    onClickAction($event: ActionDto) {
        if ($event == null)
            return;
        switch ($event.actionId) {
            case 'PUTPACKAGE':
                this.onPutPackageClick();
                break;
            case 'REMOVEPACKAGE':
                this.onRemovePackageClick();
                break;
            case 'RECOVERPACKAGE':
                this.onRecoverPackageClick();
                break;
        }
    }

    getResourcePalletCount() {
        if (this.package == null || this.package.lines == null)
            return 0;

        let palletCount = 0;
        this.package.lines.forEach(line => {
            palletCount += line.palletCount;
        });
        return palletCount;
    }

    getResourcePalletType() {

        if (this.package == null || this.package.lines == null || this.package.lines.length == 0)
            return "PALLETTYPES.NONE";

        let palletType = "PALLETTYPES.NONE";
        this.package.lines.forEach(line => {
            palletType = "PALLETTYPES." + line.palletType.toUpperCase();
        });

        return palletType;
    }


    @Output() clickCard = new EventEmitter<TruckingShipmentPackageDto>();
    onClickCard(event) {
        if (event && event.stopPropagation)
            event.stopPropagation();

        this.clickCard.next(this.package);
    }

    onDragEnter(event: DragEvent) {
        return;
    }
    onDragLeave(event: DragEvent) {
        return;
    }

    public getGeneralClass(): string {
        let result = "";

        if (this.inShipmentCard)
            result += "shipmentcard ";

        if (this.isDraggable)
            result += "dragable ";

        if (this.package != null && this.package.isTruckedPackage)
            result += "isTruckedPackage ";

        return result;
    }

    public onDragStart(event: DragEvent) {

        if (this.package == null)
            return;
        DragDropService.moverOrCopy(event);
        event.dataTransfer.setData(DragDropService.TEXTPLAIN, DragDropService.HARDMAN_TRUCKINGPACKAGEITEMDTO);
        event.dataTransfer.setData(DragDropService.HARDMANTYPE, JSON.stringify(this.package));
    }

    public packageDetail: TruckingPackageDetailDto;
    onShowDetailClick() {
        if (this.package == null)
            return;
        this.package.showDetail = !this.package.showDetail;
        if (this.package.showDetail) {
            this.clickDetail.next(true);
            this.truckingController.getTruckingPackageDetail(this.package.packageId).subscribe(data => {
                this.packageDetail = data;
            });
        } else {
            this.packageDetail = null;
        }

    }

    onPutPackageClick() {
        if (this.selectedRouteExpand == null || this.package == null)
            return;

        this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.AddPackage, this.selectedRouteExpand.routeId, 0, this.package.packageId)).subscribe(data => {
            if (data) {
                this.refresh.next(true);
                this.truckingController.shipmentChanged$.next(this.package.shipmentId);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
            }
        });

    }
    onRemovePackageClick() {
        if (this.selectedRouteExpand == null || this.package == null)
            return;

        this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.RemovePackage, this.selectedRouteExpand.routeId, 0, this.package.packageId)).subscribe(data => {
            if (data) {
                this.refresh.next(true);
                this.truckingController.shipmentChanged$.next(this.package.shipmentId);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
            }
        });

    }
    onRecoverPackageClick() {
        if (this.selectedRouteExpand == null || this.package == null)
            return;

        this.truckingController.recoverPackages(this.selectedRouteExpand.routeId, this.package.packageId, this.package.recover).subscribe(data => {
            if (data) {
                this.refresh.next(true);
                this.truckingController.shipmentChanged$.next(this.package.shipmentId);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
            }
        });

    }

    public pretty(value) {
        return JSON.stringify(value);
    }
}
